import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=cf6573c0&scoped=true&lang=html"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"
import style0 from "./Contact.vue?vue&type=style&index=0&id=cf6573c0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf6573c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf6573c0')) {
      api.createRecord('cf6573c0', component.options)
    } else {
      api.reload('cf6573c0', component.options)
    }
    module.hot.accept("./Contact.vue?vue&type=template&id=cf6573c0&scoped=true&lang=html", function () {
      api.rerender('cf6573c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Contact.vue"
export default component.exports